<template>
  <div class="english-container">
    <h2>1. Getting Started</h2>
    <p  style="text-align: left;" >To prevent accidental shutdowns that could result in the device being unable to locate, we have re-upgraded the startup and shutdown methods.
</p>
  

<h4> 1.1 Power On/Off</h4>
  <p style="text-align: left;">1.1.1 Power On:Hold the circular dot on the device's power button for 3 seconds, and when you hear a ring-ring chime, it indicates that the device has been powered on. (Refer to the diagram) </p>

   <img src="../assets/gid_1.png" alt="Wireless Tag Logo" class="image_1" />

  
  <p style="text-align: left;">
     1.1.2 Power off :Press the device button twice , and you will hear a confirmation sound. Then press and hold the power button for 3 seconds( If you press it for less than 3 seconds or more than 3 seconds, the device will not power off ), then <strong> release it... </strong> you will hear two beeps indicating it is powered off.
  </p>
  <p style="text-align: left;">
    <strong>Remark:setting a shutdown timer are designed to prevent accidental shutdowns, ensuring the device can continue to locate effectively.</strong>
  </p>

  

<h4>1.2 Check For Updates</h4>
  
      <p style="text-align: left;">
        To use the Apple® Find My® app to locate item Locator, the latest
        version of iOS®, iPadOS®, or macOS® is recommended. The Find My app on Apple Watch requires the latest version of watchOS®.    
  </p>
 

<h3>2. Add Your Locator</h3>
<h4>2.1 Start the App</h4>
<p style="text-align: left;">
  2.1.1 Open Find My app on your supported iPhone® or iPad。®
</p>
<p style="text-align: left;">
2.1.2 Allow notifications from the app.
</p>

<h4>2.2 Connect your Locator</h4>
  <p style="text-align: left;">
   2.2.1 Power on your Locator, select the “Items” tab then tap the “Add Item” tab,tap <strong>“Other Supported Items”</strong>.
</p>
<p style="text-align: left;">
2.2.2 Make sure your Item Locator is close to your phone. Wait... until you see the pop-up “Wireless tag” then tap “Connect” .
</p>

<p style="text-align: left;">
  2.2.3 Choose a recognizable name and emoji for your item Locator and tap “Continue” 
</p>

<p style="text-align: left;">
  2.2.4 Find My will ask for confirmation to add your Locator for your Apple ID - tap “Continue”.
</p>

<p style="text-align: left;">
  2.2.5 Tap “Finish” and your Locator will be set up and ready to be connected to whatever item you wish to locate, e.g., your keys.
</p>

<h3>3. Function introduction</h3>

<h4>3.1 Locate Your Item</h4>
 <p style="text-align: left;">
When your item is nearby ,tap “Play Sound” to make your Locator beep, then you can find it. When it is out of rang, you can find Locator’s Last Known Location.
  </p>

  <h4>3.2 Notifications</h4>

   <p style="text-align: left;">
You will receive a notification when you leave your Locator behind when it’s no longer in range of your device.
  </p>
  <p style="text-align: left;"> Note: “Notify When Found” can only be activated when your
Locator is out of range.</p>


  <h4>3.3 Share items</h4>
   <p style="text-align: left;">
The people you've shared it with will be able to locate it, and they
won't receive unidentified-tracking notifications.  </p>

<p style="text-align: left;">
To use Share Items, make sure you and your friends have installed the iOS 17, iPadOS 17, or macOS 14 Sonoma public betas or newer.

</p>

  <h4>3.4 Lost mode</h4>
   <p style="text-align: left;">
When your item is lost, enable lost mode, you will receive a notification when location becomes available. You can leave a phone number or email address for the finder of your item to contact you.
  </p>

     <p style="text-align: left;">
Note: When “Lost Mode” is enabled, your Locator is locked
and no one else can pair with it. And DO NOT REMOVE ITEM in the APP. Your Item Locator will be locked and cannot be used by any person.
  </p>
  
 <h4>3.5 Remove item</h4>
  <p style="text-align: left;">
Make sure your item is nearby, you can remove item in the app, it should make a ring-ring chime indicating it is removed successfully, then the item can be used by other people .
  </p>

   <p style="text-align: left;">
Note: When “Lost Mode” is enable, DO NOT REMOVE ITEM in the APP, otherwise your Item Locator will be locked and no one else
can pair with it.
  </p>

  <h4>3.6 Factory Reset Your Locator  </h4>

   <p style="text-align: left;">
When your item is out of the range of your phone, and your Locator is removed from Find My app, the device can’t be used by other people. you need reset your locator, then it can be used by other people.  </p>

   <p style="text-align: left;">
How to restore factory settings: Press the function button two times, you can hear one beep. Then Press the function button four times rapidly and then hold it a fifth time until you hear a ring-ring chime,now the device is reset. The device can be repaired to a new Apple ID account as a new device.  </p>

<h4>3.7 Unwanted Tracking Detection</h4>
<p style="text-align: left;">
If any Find My network accessory separated from its owner is seen moving with you over time, you’ll be notified in one of two ways: (1) If you have a iPhone, iPad, Find My will send a notification to your Apple device. This feature is available on iOS or iPadOS 14.5 or later. 2) If you don’t have an iOS device or smartphone, a Find My network accessory that isn’t with its owner for a period of time will emit a sound when it’s moved.</p>
<p style="text-align: left;"> 
  These features were created specifically to discourage people from trying to track you without your knowledge.
</p>
<h3>4. Specifications</h3>
<ul>  
  <li>Battery: CR2032 3V (Replaceable)</li>
  <li>Working voltage: 2.8V-3.3V</li>
  <li>Capacity: 220mAh</li>
  <li>Wireless range: 10-30 meters</li>
  <li>Buzzer: Max 100 DB</li>
  <li>Product size:φ32X7.9mm</li>

  </ul>



  <h3>5. Button function</h3>
  <ol>
    <li style="text-align: left;">
      <strong>Power on (Find my function is on).</strong>
      <p>
        Press the function button 3 seconds to turn it on. it should a ring-ring chime indicating it is powered on.        </p>
      <p> If the product is not linked with your apple ID, it will be closed within 10 minutes automatically. You need to trigger the find my function again to continue pairing.</p>
      </li>
    <li style="text-align: left;"> <strong>Power off (Find my function is off ).</strong> 
      <p>
        Hold the function button for three seconds, then release it.. you will hear two beeps indicating it is powered off.      </p>
    </li>
     <li style="text-align: left;"> <strong>Enable learn more information query.</strong> 
      <p>
Press the function button two times rapidly and you will hear a confirmation sound,This operation will be displayed on the find my app to guide the person who gets the device to obtain the device
</p>

      <p>
information, such as the owner's contact information (if the item is set to the lost mode on the app), and the serial number of the device.
</p>
</li>

 <li style="text-align: left;"> <strong> Restore factory settings</strong>
  <p>
Press the function button two times, you can hear one beep, then Press the function button four times rapidly and then hold it a fifth time until you hear a ring-ring chime, now the device is reset.</p>
  
<p style="text-align: left;">
A reset operation is required to make the device enter the pairing state</p>

</li>
</ol>

 <h3>6. Battery and Lanyard replacement</h3>
 <ol> 
    <li>Insert the shell opening with a shell opening tool.</li>
    <li>Rotate the shell opening tool 90 degrees to open the shell.</li>
    <li>Use your fingernails at the small gap on the side of your Item Locater to carefully open the case.</li>
    <li>Replace the battery with a new CR2032 battery 3V. (Positive pole with the text upward).</li>

 </ol>

      <img src="../assets/open_tag.png" alt="Wireless Tag Logo" class="image_1" />
      <img src="../assets/open_tag_2.png" alt="Wireless Tag Logo" class="image_1" />



  <h3>  FAQ  </h3>
  <h4>1. Why find my device’s location not updating.</h4>
    <li style="text-align: left;">There are two principles for product positioning reporting. If there are many Apple devices nearby, each new user in the vicinity of this device will report their location, typically within 2-5 minutes. If the device has not moved, the built-in sensors will detect this, and the device will enter a sleep mode, with the reported location ranging from 30 minutes to several hours. Don’t worry, the location you see might be from 30 minutes or several hours ago, but it’s very likely that the item hasn’t moved, and the location you see is the last known location.</li>
<h4>2. When pairing a device with Find My app, the phone will link to the Apple server. Pairing may fail because of network problems. The following action is recommended: </h4>
<ol>
  <li style="text-align: left;">Change the phone’s network, such as switching between WiFi and mobile. The first pairing may takes a long time, please wait patiently.
</li>
  <li style="text-align: left;">Reset your item.</li>
<li style="text-align: left;"> Repair with Find my APP.
</li>
</ol>
<h3>Privacy and Security</h3>
<p style="text-align: left; color:#333 "  >Your Locator sends out a secure Bluetooth signal that can be detected by nearby devices in the Find My network. These devices send the location of your Locator to iCloud — then you can go to the Find My app and see it on a map. The whole process is anonymous and encrypted to protect your privacy.</p>

<h3>WARNING</h3>
<ol>
  <li>Remove and Immediately recycle or dispose of used batteries according to local regulations and keep away from children. Do NOT dispose of batteries in household trash or incinerate.</li>
  <li>Even used batteries may cause severe injury or death.</li>
  <li>Call a local poison control center for treatment information.</li>
  <li>Non-rechargeable batteries are not to be recharged.</li>
  <li>Do not force discharge, recharge, disassemble, heat above 50°C/122°F or incinerate.</li>
  <li>Doing so may result in injury due to venting, leakage or explosion resulting in chemical burns.6. The compatible battery type is CR2032.</li>
  <li>The nominal battery voltage: DC 3V</li>
  <li>Ensure the batteries are installed correctly according to polarity(+ and -). 9. Do not mix old and new batteries, different brands or types of batteries, such as alkaline, carbon-zinc, or rechargeable batteries.</li>
  <li>Remove and immediately recycle or dispose of batteries from equipment not used for an extended period of time according to local regulations.</li>
  <li> Always completely secure the battery compartment. If the battery compartment does not close securely, stop using the product, remove the batteries,and keep them away from children.</li>
</ol>
<h5>
  <p>Battery type: CR2032. Battery voltage: 3V.</p>
<p>Keep in original package until ready to use;</p>
<p>Immediately dispose of used batteries and keep away from children. Do NOT dispose of batteries in household trash.</p>
</h5>

<img src="../assets/image_battery.png" class="image_1">

</div>

</template>

<script>
export default {
  name: 'IosEnglish',
};
</script>

<style scoped>
.english-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1, h2,h3,h4,h5 {
  color: #333;
 text-align: left; /* 明确标题左对齐（如果父级未继承） */

}
ul, ol {
  margin-left: 20px;
  padding-left: 15px;
 list-style-type: decimal; /* 强制显示数字编号 */

}
li {
  margin-bottom: 8px;
  text-align: left;
  color: #000000;
}

.image_1 {
  width: 90%; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}

</style>